import { mapToCamelCase, mapToSnakeCase } from '@consigli/utils';
import { z } from 'zod';
import { buildingPackageSchema } from './building-package';
export const buildingJSONSchema = z
    .object({
    id: z.string().uuid(),
    building_package_id: buildingPackageSchema.innerType().shape.id,
    data: z.object({}).passthrough().nullable(),
    updated_at: z.string(),
    created_at: z.string(),
})
    .strict()
    .transform(mapToCamelCase);
export const createBuildingJSONRequestSchema = z
    .object({
    data: z.object({}).passthrough().nullable(),
})
    .strict()
    .transform(mapToSnakeCase);
export const createBuildingJSONResponseSchema = z.object({}).passthrough();
export const updateBuildingJSONRequestSchema = z
    .object({
    data: z.object({}).passthrough().nullable(),
})
    .partial()
    .strict()
    .transform(mapToSnakeCase);
export const updateBuildingJSONResponseSchema = z.object({}).passthrough();
